import React, { useState } from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Spinner, SelectInput, useAsync, Link, Box } from '@wix/cli-ui-kit';
import { Trans, useTranslation } from '@wix/cli-i18n';
import { useDevCenterClient } from '@wix/dev-center-client';
import type { CliAppTemplate } from '@wix/dev-center-client';
import { useCreateAppBi } from '../bi/index.js';

interface ChooseTemplateProps {
  onSelected: (template: CliAppTemplate) => void;
}

export const ChooseTemplate: FC<ChooseTemplateProps> = ({ onSelected }) => {
  const { t } = useTranslation();
  const { cliFlowStepAnswered } = useCreateAppBi();
  const { queryCliAppTemplates } = useDevCenterClient();

  const [isTemplateSelected, setIsTemplateSelected] = useState(false);

  const { status } = useAsync(async () => {
    const appTemplates = await queryCliAppTemplates();

    return {
      appTemplatesOptions: appTemplates.map((appTemplate) => {
        return {
          key: appTemplate.id,
          title: appTemplate.title,
          description: appTemplate.subtitle,
          value: appTemplate,
        };
      }),
    };
  }, []);

  return (
    <>
      {match(status, {
        Error: () => null,
        Loading: () => <Spinner />,
        Success: ({ result: { appTemplatesOptions } }) => (
          <>
            <SelectInput
              label={t('create_app.choose_template.title')}
              options={appTemplatesOptions}
              onSubmit={({ value }) => {
                cliFlowStepAnswered({
                  question: t('create_app.choose_template.title'),
                  questionKey: 'create_app.choose_template.title',
                  answer: value.title,
                });
                setIsTemplateSelected(true);
                onSelected(value);
              }}
            />
            {!isTemplateSelected && (
              <Box marginTop={1}>
                <Trans
                  i18nKey="create_app.choose_template.see_templates"
                  components={[
                    <Link url="https://dev.wix.com/apps-templates?filter=cli" />,
                  ]}
                />
              </Box>
            )}
          </>
        ),
      })}
    </>
  );
};
